// When the site is opened directly through the server's public IP (dev access),
// talk to Strapi directly over plain HTTP to avoid the invalid SSL cert on
// api.jvbtechnics.synology.me. Any other hostname (carwrapartist.be,
// app.jvbtechnics.synology.me, localhost, ...) keeps using VITE_API_URL.
const DEV_IP = '213.118.117.139'

const getApiUrl = () => {
  if (typeof window !== 'undefined' && window.location.hostname === DEV_IP) {
    return `http://${DEV_IP}:1337`
  }
  return import.meta.env.VITE_API_URL || 'http://localhost:1337'
}

export const API_URL = getApiUrl()
